import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { api__createPaymentSessionValidation } from "@/apis/checkout/createSession";
import usePaymentHook from "@/pages/checkout/CheckoutV2/hooks/usePaymentHook";
import stl from "@/pages/checkout/CheckoutV2/Checkout.module.css";
import { CDN_LINK } from "@globalConfig";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import useFullLoading from "@hooks/useFullLoading";
import toast from "react-hot-toast";
import useIsMobile from "@hooks/useIsMobile";
import CreditCardInfoShimmer from "@/pages/checkout/CheckoutV2/components/CreditCardInfoShimmer";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import useBoolean from "@hooks/useBoolean";
import PaymentInfoV2 from "@/pages/checkout/components/PaymentInfo/PaymentInfoV2";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
var Checkout = function Checkout(_ref) {
  var _checkoutOrderV2$post, _checkoutOrderV2$post2;
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    referralData = _ref.referralData,
    paymentSession = _ref.paymentSession,
    paymentProcessingUrl = _ref.paymentProcessingUrl,
    order_id = _ref.order_id;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var loading = useFullLoading();
  var grantedPopup = useBoolean();
  var on_initiating = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var orderId, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            // Prefer loaded order id, fall back to the URL-derived order_id.
            // checkoutOrderV2 can be null after a Back navigation (context reset,
            // no get-details refetch) — without this fallback order_id is sent undefined.
            orderId = (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id) || order_id;
            if (orderId) {
              _context.n = 1;
              break;
            }
            toast.error(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }));
            return _context.a(2, false);
          case 1:
            _context.n = 2;
            return api__createPaymentSessionValidation({
              order_id: orderId,
              paymentProcessingUrl: paymentProcessingUrl
            });
          case 2:
            return _context.a(2, {});
          case 3:
            _context.p = 3;
            _t = _context.v;
            if (_t.trace) {
              toast.error(_t.trace);
            } else {
              toast.error(_t.message);
            }
            return _context.a(2, false);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function on_initiating() {
      return _ref2.apply(this, arguments);
    };
  }();
  var on_completed = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2, navigateTo("/payedsuccess?order_id=".concat((checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id) || order_id, "&paymentStatus=paid")));
        }
      }, _callee2);
    }));
    return function on_completed() {
      return _ref3.apply(this, arguments);
    };
  }();
  usePaymentHook({
    divSelector: '.mysr-form',
    paymentSession: paymentSession.paymentSession,
    gatewayType: paymentSession.gateway_type,
    events: {
      on_initiating: on_initiating,
      on_completed: on_completed
    },
    template: {
      payButtonText: t("complete_pay_deposit", {
        ns: "web_checkout_cash"
      })
    },
    internvalTimeoutSeconds: 10
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDesktop && /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.backBtn].join(" ")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return navigateTo("/checkout/shop-apply?post_id=".concat(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.post_id));
    }
  }, t("cancel", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.moyasarFormWrapper
  }, /*#__PURE__*/React.createElement(HeadingSteps, {
    className: stl.steps
  }, /*#__PURE__*/React.createElement("span", {
    className: "completed"
  }, t("add_information", {
    ns: "web_checkout_cash"
  })), localStorage.getItem("otp_visited_".concat(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.id)) === "1" && /*#__PURE__*/React.createElement("span", {
    className: "completed"
  }, t("verify_code", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("span", {
    className: "active"
  }, t("payment", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: stl.payTitle
  }, t("choose_payment_method", {
    ns: "web_checkout_cash"
  })), isMobile && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mb-6",
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: grantedPopup.setTrue
  }), /*#__PURE__*/React.createElement("div", {
    className: "mysr-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(CreditCardInfoShimmer, null))), isMobile && /*#__PURE__*/React.createElement(Disclaimer, {
    className: stl.Disclaimer
  })), isDesktop && /*#__PURE__*/React.createElement("div", {
    className: stl.stickyContainer
  }, /*#__PURE__*/React.createElement(PaymentInfoV2, {
    loading: loading,
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: grantedPopup.setTrue
  }), (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.post_is_new) != 1 && (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    img: CDN_LINK + "/assets/images/dm10.svg"
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  }))))));
};
export default Checkout;